import Lottie from "lottie-react";
import LottieIcon from "./ShareAnimation.json";
import { useRef } from "react";

const ShareAnimationComponent = ({ className }) => {
  const lottieRef = useRef(null);

  const handleClick = () => {
    if (lottieRef.current) {
      lottieRef.current.goToAndPlay(0, true);
    }
  };

  return (
    <div onClick={handleClick} className="tw-cursor-pointer">
      <Lottie
        lottieRef={lottieRef}
        animationData={LottieIcon}
        loop={false}
        autoplay={false}
        className={`${className ?? "tw-w-20"} `}
      />
    </div>
  );
};

export default ShareAnimationComponent;
